exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.body[data-v-2bc7ec38] {\n  color: #2a2e51;\n  padding: 0px;\n  background: white;\n  border-radius: 4px;\n  border: 1px solid #b1b4cd;\n}\n.sidebar[data-v-2bc7ec38] {\n  width: 250px;\n  border-right: 1px solid #b1b4cd;\n  flex-shrink: 0;\n}\n.detail[data-v-2bc7ec38] {\n  flex-grow: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bc7ec38","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/usr/src/app/src/assets/_include-media.scss","/usr/src/app/src/assets/palette.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/event/attendees.vue
// module id = UtL+
// module chunks = 1